<script setup>
import { computed } from 'vue';
import { useInvoiceModalStore } from '@organisms/ubiq-administration/store/invoiceModal';
import { useInvoiceStore } from '@organisms/ubiq-administration/store/invoices';
import { useSubscriptionStore } from '@organisms/ubiq-administration/store/subscriptions';
import { INVOICE_STATUS } from '../../constants/constants';
import MenuDropdown from '../../../../_02_molecules/components/MenuDropdown.vue';
import DownloadInvoiceAction from '../actions/DownloadInvoiceAction.vue';
import SeeRelatedSubscriptionAction from '../actions/SeeRelatedSubscriptionAction.vue';
import MarkAsStatusAction from '../actions/MarkAsStatusAction.vue';

const subscriptionStore = useSubscriptionStore();
const invoiceStore = useInvoiceStore();
const { setModal } = useInvoiceModalStore();

const subscriptionData = computed(() => subscriptionStore.selectedSubscriptionData);

const props = defineProps({
  invoice: {
    type: Object,
    required: true,
  },
});

const openModal = ({ title, name }) => {
  invoiceStore.setSelectedInvoice(props.invoice);
  setModal({
    modalTitle: title,
    modalComponentName: name,
    shouldOpenModal: true,
  });
};

const invoiceStatus = computed(() => props.invoice.status?.toLowerCase() ?? null);
</script>

<template>
  <MenuDropdown>
    <template #start>
      <ul>
        <template v-if="[ INVOICE_STATUS.OPEN, INVOICE_STATUS.PAYMENT_OVERDUE ].includes(invoiceStatus)">
          <MarkAsStatusAction :type="invoice.type" :status="INVOICE_STATUS.PAID" @openModal="openModal" />
        </template>

        <DownloadInvoiceAction v-if="invoice.invoice_url" :invoice-url="invoice.invoice_url" class="dropdown-ubiq--separator" />
        <SeeRelatedSubscriptionAction v-if="!subscriptionData" :subscription-id="invoice.subscription?.id" class="dropdown-ubiq--separator" />
      </ul>
    </template>
  </MenuDropdown>
</template>
